export default __webpack_public_path__ + "static/media/kusa.01e9fc7d.png";